import { render, staticRenderFns } from "./TableCellTypeUrl.vue?vue&type=template&id=1a6b83d8&scoped=true"
import script from "./TableCellTypeUrl.vue?vue&type=script&lang=js"
export * from "./TableCellTypeUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6b83d8",
  null
  
)

export default component.exports